import { useReportFiltersStore } from "@repo/core/stores/reports-filters";
import { subDays, subMonths } from "date-fns";
import { useState } from "react";

const currentDay = new Date();

export const useReportsFilters = () => {
  const { selectedAttendant, selectedProduct, selectedStore } =
    useReportFiltersStore();

  const [filterStartDate, setFilterStartDate] = useState(
    subMonths(currentDay, 12)
  );

  const [filterEndDate, setFilterEndDate] = useState(subDays(currentDay, 1));

  const onChangeStartDate = (date: Date | null) => {
    if (date) {
      setFilterStartDate(date);
    }
  };

  const onChangeEndDate = (date: Date | null) => {
    if (date) {
      setFilterEndDate(date);
    }
  };

  return {
    selectedProduct,
    selectedAttendant,
    selectedStore,
    filterStartDate,
    filterEndDate,
    onChangeStartDate,
    onChangeEndDate
  };
};
